import React from 'react'
import { Heading } from '@myxplor/ui'

const Empty = () => <Heading small>No B2B Device Registered</Heading>

export default Empty



// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/empty.jsx